import { render, staticRenderFns } from "./EpTerdaftar.vue?vue&type=template&id=6ddfddf5&scoped=true&"
import script from "./EpTerdaftar.vue?vue&type=script&lang=js&"
export * from "./EpTerdaftar.vue?vue&type=script&lang=js&"
import style0 from "./EpTerdaftar.vue?vue&type=style&index=0&id=6ddfddf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddfddf5",
  null
  
)

export default component.exports